import { css } from '@emotion/react'

export const dynamicStyle = (brandColorHex: string) =>
  css`
    border: 0px !important;

    div.react-datepicker-wrapper {
      display: block !important;
      max-height: 0 !important;
    }

    .react-datepicker__input-container {
      display: none;
    }

    div.react-datepicker__triangle {
      display: none;
    }

    div.react-datepicker__month-container {
      font-family: Plus Jakarta Sans, helvetica, arial, sans-serif;

      color: var(--chakra-colors-onyx);
      box-shadow: var(--chakra-shadows-xlDark);
      border-radius: 12px;
      background-color: white;
      padding: 8px 16px 12px 16px;
    }

    div {
      background-color: transparent;
      border: 0px;
    }

    div[role='option'] {
      width: 28px;
      height: 28px;
      line-height: 28px;
      vertical-align: middle;
    }

    p {
      vertical-align: middle;
      height: 100%;
    }

    div.react-datepicker__day-name {
      color: var(--chakra-colors-stone);
      width: 32px;
      margin-top: 16px;
      margin-bottom: 12px;
      font-size: 12px;
    }

    div.react-datepicker__day {
      font-size: 12px;
      border-radius: 50%;
      padding: 2px;
      box-sizing: content-box;
    }

    .react-datepicker__day--today {
      font-weight: 700;
      background-color: ${brandColorHex}11;
    }

    div[aria-selected='true'] {
      background-color: ${brandColorHex};
      border: 0px;
      border-radius: 50%;
    }

    div[aria-selected='true'] p {
      color: white !important;
    }

    .react-datepicker__day--outside-month > p {
      opacity: 0.4;
    }

    .react-datepicker__day[aria-selected='false']:hover,
    .react-datepicker__day--keyboard-selected:hover {
      background-color: #eee;
    }
  `
